import { useApmUser, useNuxtApp, useUserInfo, watch } from '#imports'

/**
 * Contributes the logged-in user's id to APM as ECS `user.id`, so frontend RUM
 * correlates with backend logs in Kibana. Call once from the app root (`App.vue`)
 * setup — the app-wide analogue of how `usePlaygameApmLabels` is called from the
 * playgame view.
 *
 * The id is stringified to byte-match the backend's keyword `user.id`. The APM plugin
 * applies the registered identity once when the agent is ready; this re-applies whenever
 * the login state changes (the user query typically resolves after the agent installs).
 */
export const useUserApmContext = (): void => {
    if (import.meta.server) return

    const nuxtApp = useNuxtApp()
    const { isLoggedIn, data } = useUserInfo()
    const { registerUser, applyUser } = useApmUser()

    registerUser(() => (isLoggedIn.value && data.value?.id != null ? { id: String(data.value.id) } : null))

    watch(isLoggedIn, () => {
        // Read the agent fresh — it is installed on the Vue app after this setup runs.
        applyUser(nuxtApp.vueApp.config.globalProperties.$apm)
    })
}
